import styled, { css } from 'styled-components';
import {
  mediaDesktop,
  mediaTablet,
  mediaTabletAndPortrait,
} from 'utils/responsive';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  height: 4vh;
  margin-top: 6vh;
  user-select: none;
  ${mediaTablet(css`
    height: 5vh;
  `)}
  ${mediaTabletAndPortrait(css`
    height: 4vh;
  `)}
  ${mediaDesktop(css`
    height: 4vh;
    min-height: 0;
    margin-top: 6vh;
  `)}
`;
